import type { ReactNode } from "react";
import { useState } from "react";
import { motion } from "framer-motion";

import wpp from "../assets/contact-button-icon.webp";
import { useMediaQuery } from "@/lib/media";

type ButtonProps = {
  href?: string;
  children?: ReactNode;
};

export default function QuoteButton({ href, children }: ButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  const canHover = useMediaQuery("(hover: hover) and (pointer: fine)");
  const expanded = canHover && isHovered;

  return (
    <>
      <a
        className="btn-quote group relative flex items-center justify-center overflow-hidden rounded-full h-12 w-12 shrink-0 md:h-auto md:w-62 md:justify-between md:px-4 md:py-2 md:text-base"
        href={href}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <motion.span
          animate={{ opacity: expanded ? 0 : 1 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="sr-only md:not-sr-only md:flex md:items-center md:h-full md:py-1 md:text-nowrap md:px-2"
        >
          {children}
        </motion.span>
        <motion.span
          animate={{ width: expanded ? 230 : 32 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="bg-white h-8 min-w-8 p-2 rounded-full flex items-center justify-center overflow-hidden md:absolute md:right-0 md:mx-2"
        >
          <img src={wpp} alt="" width={16} height={16} className="shrink-0" />
        </motion.span>
      </a>
    </>
  );
}
